import { CustomError } from './custom-error';

export class PlanNotGeneratedError extends CustomError {
  constructor({
    message = 'A non-existing plan cannot be retrieved.',
    data,
    name = 'PLAN_NOT_GENERATED_ERROR',
  }: { message?: string; data?: unknown; name?: string } = {}) {
    super({ message, data, name });

    Object.setPrototypeOf(this, PlanNotGeneratedError.prototype);
  }
}
